import { useRef, useCallback } from 'react';

/**
 * @param customColor string, default: #B7FF00 - lime
 * @returns setCustomColor and resetColor functions
 */
export const useMerlinLogoColor = (customColor: string) => {
  // document.querySelectorAll(`[id^="box"]`); TODO
  const el = document.getElementById('merlinLogo');
  const logoRef = useRef({
    customColor: customColor,
    originalColor: el?.style.color,
    customZIndex: '100',
    originalZIndex: el?.style.zIndex,
  });

  const setCustomColor = useCallback(() => {
    el && (el.style.color = logoRef.current.customColor);
    el && (el.style.zIndex = logoRef.current.customZIndex);
  }, []);

  const resetColor = useCallback(() => {
    el && (el.style.color = logoRef.current.originalColor!);
    el && (el.style.zIndex = logoRef.current.originalZIndex!);
  }, []);

  return { setCustomColor, resetColor };
};
